import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material"
import { ParkingFinderModalProps } from "containers/ParkingFinderContainer"
import { ComponentType } from "react"

//todo: create actual StandardParkingFinderModal
export const StandardParkingFinderModal: ComponentType<
  ParkingFinderModalProps
> = ({ note, onChangeTextField, closeModal, handleSave }) => {
  return (
    <>
      <DialogTitle>Save Parking</DialogTitle>
      <DialogContent>
        <TextField
          value={note}
          onChange={onChangeTextField}
          fullWidth
          multiline
          rows={2}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={closeModal}>Cancel</Button>
        <Button onClick={handleSave} variant="contained">
          Save
        </Button>
      </DialogActions>
    </>
  )
}
